const FAKE_FAVOURITES_CLASS = ".fake-favourite";
const APARTMENTS_LISTING_CLASS = ".element-property-apartments-listing";

/**
 * Initialize single-cost-unit "all-apartments with apartment-type" block
 * @returns {void}
 */
export const initializeCostUnitApartmentsListing = () => {
  const costUnitApartmentsListing = document.querySelector(
    APARTMENTS_LISTING_CLASS,
  );
  if (costUnitApartmentsListing) {
    listenButtonForApartmentsCategory(costUnitApartmentsListing);
  }

  const fakeFavouriteButtons = document.querySelectorAll(FAKE_FAVOURITES_CLASS);
  if (fakeFavouriteButtons?.length > 0) {
    fakeFavouriteButtons.forEach((button) => {
      initializeFakeFavouriteButton(button);
    });
  }
};

/**
 * Add eventlistener for apartments-listing block
 * @param {HTMLElement} costUnitApartmentsListing
 * @returns {Event}
 */
const listenButtonForApartmentsCategory = (costUnitApartmentsListing) => {
  costUnitApartmentsListing.addEventListener("click", function (e) {
    if (!e.target.closest(".close")) {
      return e;
    }

    const close = e.target.closest(".close");
    const costUnitDiv = close.parentNode;
    const singleContainer = costUnitDiv.parentNode;

    const apartmentInfos = singleContainer.querySelectorAll(
      ".apartments .apartment-info",
    );

    const openedApartments = JSON.parse(close.getAttribute("data-open"));
    const text = close.querySelector(".text");

    apartmentInfos.forEach((info) => {
      if (openedApartments) {
        info.setAttribute("data-visible", "false");
        text.textContent = close.getAttribute("data-open-text");
        return;
      }
      // Not opened
      info.setAttribute("data-visible", "true");
      text.textContent = close.getAttribute("data-close-text");
    });

    close.setAttribute("data-open", !openedApartments);
    return e;
  });
};
/**
 * Modify necessary DOM manipulations and add event listeners for the button
 * @param {HTMLElement} fakeFavourite
 * @returns {void}
 */
const initializeFakeFavouriteButton = (fakeFavourite) => {
  const costUnitContainer = fakeFavourite.parentNode;
  const singleContainer = costUnitContainer.parentNode;
  const apartments = singleContainer.querySelectorAll(".apartment-info");

  let countActives = 0;
  let countNotActives = 0;

  apartments.forEach((apartment) => {
    if (apartment.classList.contains(".active")) {
      countActives++;
      return;
    }
    countNotActives++;
  });

  if (countActives === apartments?.length) {
    // All are checked
    fakeFavourite.classList.add("active");
    const text = fakeFavourite.querySelector(".modified-text");
    text.textContent = fakeFavourite.getAttribute("data-remove-button-text");
  }

  if (countNotActives === apartments?.length) {
    fakeFavourite.classList.remove("active");
  }

  listenFakeFavourite(fakeFavourite);
};

/**
 * Add event listener for fake-favourite button
 * @param {*} fakeFavourite
 */
const listenFakeFavourite = (fakeFavourite) => {
  fakeFavourite.addEventListener("click", function (e) {
    const fakeFavourite = e.target.closest(".fake-favourite");

    if (!fakeFavourite) {
      return;
    }

    let currentlyActive = false;
    const modifiedText = fakeFavourite.querySelector(".modified-text");

    if (fakeFavourite.classList.contains("active")) {
      currentlyActive = true;
      fakeFavourite.classList.remove("active");
      modifiedText.textContent = fakeFavourite.getAttribute(
        "data-add-button-text",
      );
    } else {
      fakeFavourite.classList.add("active");
      modifiedText.textContent = fakeFavourite.getAttribute(
        "data-remove-button-text",
      );
    }

    const costUnitContainer = fakeFavourite.parentNode;
    const singleContainer = costUnitContainer.parentNode;
    const apartments = singleContainer.querySelectorAll(".apartment-info");

    apartments.forEach((apartment) => {
      const apartmentFavourite = apartment.querySelector(".favourite");

      if (currentlyActive && apartmentFavourite.classList.contains("active")) {
        apartmentFavourite.click();
      }

      if (
        !currentlyActive &&
        !apartmentFavourite.classList.contains("active")
      ) {
        apartmentFavourite.click();
      }
    });
  });
};
